import { usePageControls } from '~/api/hooks/useCharts'
import { labelFor } from './kpiLabel'

/** Display label for a kpi_id, resolved via get_controls kpi_metadata. kpi_metadata is
 *  registry-wide (not fact-filtered), so any valid factTable resolves any registry kpi —
 *  pins pass their own walk_call.fact_table. Returns the raw kpi_id while controls load. */
export function useKpiDisplayLabel(factTable: string, kpiId: string): string {
  const controls = usePageControls(factTable)
  return labelFor(controls, kpiId)
}
